import Link from 'next/link';

import { Account, Entry } from '@/types/cit-public-api';

import { getEntryLink } from '@/lib/navigationUtils';
import { getThumbnailSlotValues } from '@/lib/customization-utils';
import { getPrimaryThumbnailPath } from '@/lib/media-utils';

export default function EntryCard({
  entry,
  account,
  searchQuery,
  classificationId,
  folderId,
  imageSize,
  textBoxHeight,
  mediaAddornment,
  handleShowToolTip,
  handleHideToolTip,
  fromAllSearch,
  fromAccountSearch,
  prefix
}: {
  entry: Entry;
  account?: Account;
  searchQuery?: string | null;
  classificationId?: string;
  folderId?: string;
  imageSize?: number;
  textBoxHeight?: number;
  mediaAddornment?: string;
  handleShowToolTip: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  handleHideToolTip: () => void;
  fromAllSearch?: boolean;
  fromAccountSearch?: boolean;
  prefix?: string;
}) {
  let slot1 = '';
  let slot2 = '';
  let slot3 = '';

  [slot1, slot2, slot3] = getThumbnailSlotValues(account, entry);

  const imagePath = getPrimaryThumbnailPath(entry?.media, account);

  return (
    <Link
      key={entry.id}
      href={
        // include the search query in the url if it exists, so that the entry carousel can use it
        searchQuery
          ? getEntryLink(
              entry.account_slug || entry.account_id,
              entry.slug || entry.id,
              classificationId,
              folderId,
              fromAccountSearch,
              fromAllSearch,
              prefix
            ) + `?query=${searchQuery}`
          : getEntryLink(
              entry.account_slug || entry.account_id,
              entry.slug || entry.id,
              classificationId,
              folderId,
              fromAccountSearch,
              fromAllSearch,
              prefix
            )
      }
      className='hover:opacity-90 transition-opacity h-full'
      onMouseEnter={handleShowToolTip}
      onMouseLeave={handleHideToolTip}
      data-tooltip-content={slot1}
      data-tooltip-id={entry.id || entry.slug}
      // should be false so page does not scroll to top when modal is opened
      scroll={false}
      prefetch={false}
    >
      <div className='h-full flex flex-col'>
        <div
          style={{
            width: imageSize ? `${imageSize}px` : '100%',
            height: imageSize ? `${imageSize}px` : 'auto',
            aspectRatio: imageSize ? undefined : '1'
          }}
          className='relative'
        >
          <img
            src={imagePath}
            alt={slot1}
            className={`absolute z-10 ${
              mediaAddornment === 'rounded' ? 'rounded-lg' : 'rounded-none'
            }`}
            loading='lazy'
          />
        </div>
        <div style={{ height: textBoxHeight ? `${textBoxHeight}px` : 'auto' }}>
          {slot1 ? <h6 className='slot1'>{slot1}</h6> : null}
          {slot2 ? <p className='slot2'>{slot2}</p> : null}
          {slot3 ? <p className='slot3'>{slot3}</p> : null}
        </div>
      </div>
    </Link>
  );
}
